// extracted by mini-css-extract-plugin
module.exports = {"container":"FixedQuery_container__Bg2fq","search-icon":"FixedQuery_search-icon__3rU3z","search-text":"FixedQuery_search-text__kFv0o"};